export const jobs = [
  {
    id: 1,
    title: "Frontend Developer",
    type: "Full-time",
    location: "Remote / Pune, India",

    description:
      "We are seeking a talented Frontend Developer to join our dynamic team. You will be responsible for building modern and responsive user interfaces.",

    responsibilities: [
      "Develop responsive web applications using React",
      "Collaborate with UI/UX designers",
      "Optimize application performance",
      "Write clean and maintainable code",
      "Work with backend developers for API integration"
    ],

    requirements: [
      "Strong knowledge of HTML, CSS and JavaScript",
      "Experience with React JS",
      "Understanding of REST APIs",
      "Git and GitHub knowledge",
      "Problem-solving skills"
    ],

    preferredQualifications: [
      "Knowledge of Tailwind CSS",
      "Experience with TypeScript",
      "Understanding of Redux",
      "Portfolio of projects"
    ]
  },

  {
    id: 2,
    title: "Senior Sales Manager",
    type: "Full-time",
    location: "Remote / Pune, India",

    description:
      "Build scalable React applications and reusable UI components for enterprise solutions.",

    responsibilities: [
      "Create reusable React components",
      "Integrate APIs",
      "Manage application state",
      "Optimize UI performance"
    ],

    requirements: [
      "React Hooks knowledge",
      "JavaScript ES6+",
      "API integration experience",
      "Responsive design skills"
    ],

    preferredQualifications: [
      "Redux Toolkit",
      "Next.js knowledge",
      "Tailwind CSS"
    ]
  },

  {
    id: 3,
    title: "Sales Executive",
    type: "Full-time",
    location: "Remote / Pune, India",

    description:
      "Design engaging and user-friendly interfaces for web and mobile applications.",

    responsibilities: [
      "Create wireframes",
      "Design prototypes",
      "Conduct user research",
      "Collaborate with developers"
    ],

    requirements: [
      "Knowledge of Figma",
      "UI Design principles",
      "Creative thinking"
    ],

    preferredQualifications: [
      "Adobe XD",
      "Portfolio projects",
      "Interaction design knowledge"
    ]
  },

  {
    id: 4,
    title: "Backend Engineer",
    type: "Full-time",
    location: " Remote / Pune, India",

    description:
      "Develop secure and scalable backend services and APIs.",

    responsibilities: [
      "Build REST APIs",
      "Database design",
      "Server-side development",
      "Performance optimization"
    ],

    requirements: [
      "Node.js or Java Spring Boot",
      "MySQL / MongoDB",
      "API development experience"
    ],

    preferredQualifications: [
      "Cloud knowledge",
      "Docker basics",
      "Microservices experience"
    ]
  },


  {
    id: 5,
    title: "DevOps Specialist",
    type: "Full-time",
    location: " Remote / Pune, India",

    description:
      "Develop secure and scalable backend services and APIs.",

    responsibilities: [
      "Build REST APIs",
      "Database design",
      "Server-side development",
      "Performance optimization"
    ],

    requirements: [
      "Node.js or Java Spring Boot",
      "MySQL / MongoDB",
      "API development experience"
    ],

    preferredQualifications: [
      "Cloud knowledge",
      "Docker basics",
      "Microservices experience"
    ]
  }
];